<template src="./vehicleinspectionview.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import VehicleInspectionViewDetails from "@/pages/vehicleinspections/vehicleinspectionview/vehicleinspectionviewdetails.vue";
  import VueHtml2pdf from "vue-html2pdf";
  var moment = require("moment");
  export default {
    components: {
      VehicleInspectionViewDetails,
      VueHtml2pdf,
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
    },
    data() {
      return {
        ShowLoader: false,
        VehicleInspectionSubmitId: 0,
        VehicleInspections: [],
        FleetInspectionsList: [],
        CompanyChecks: [],
        CompanyLogo: "",
        MileageUnit: "Mileage",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        biglightgallery: [],
        tyresData: [],
        brakesData: [],
        VehicleType: "Vehicle",
        base64_image: "",
      };
    },
    mounted() {
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions.Vehicle ||
          !AccountPermissions["HGV"] ||
          !AccountPermissions["HGV"]["view_vehicle_inspections"])
      ) {
        this.$router.push("/");
      }
      document.title = pbx_SiteTitle + " - Vehicles Inspection View";
      this.VehicleInspectionSubmitId = this.$route.params.Id;
      this.GetCompanySubscription();
      var Company = JSON.parse(localStorage.getItem("Company"));
      if (Company) {
        this.CompanyLogo = Company.logo;
        this.GenerateBase64Logo();

        if (CompanyData && Company.mileage_unit == 2) {
          this.MileageUnit = "KM";
        }
      }

      this.$root.$on("GenerateInspectionPDF", () => {
        this.GenerateInspectionPDF();
      });
    },

    methods: {
      GenerateBase64Logo() {
      var obj = {
        token: localStorage.getItem("token"),
        url: this.ImageEndpoint + this.CompanyLogo,
      };
      Axios.post(Endpoints.File.GetBase64Image, obj).then((Response) => {
        if (Response?.data?.success) {
          this.base64_image = Response.data.image_data;
        }
      });
    },
      GenerateInspectionPDF() {
        // Generate the PDF
        this.$refs.html2InspectionPdf.generatePdf();
      },
      PDFDownloaded() {
        $("#save_pdf_btn").html("Save as PDF");
      },
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isHGV = FleetSubscriptionModules.HGV;
        if (isHGV) {
          this.GetVehicleInspectionsList();
        } else {
          this.$router.push("/");
        }
      },
      SearchVehicle() {
        this.GetVehicleInspectionsList();
      },
      GetVehicleInspectionsList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        obj.vehicleInspectionSubmitId = this.VehicleInspectionSubmitId;
        this.ShowLoader = true;
        Axios.post(
          Endpoints.VehicleInspections.VehicleInspectionView,
          obj
        ).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.VehicleInspections = Response.data.FleetInspectionSubmitData;
            this.FleetInspectionsList = Response.data.FleetInspections;
            //console.log(this.FleetInspectionsList);
            if (
              this.VehicleInspections.vehicle &&
              this.VehicleInspections.vehicle.class == "Trailer"
            ) {
              this.VehicleType = "Trailer";
            }
            if (
              this.VehicleInspections.vehicle &&
              this.VehicleInspections.vehicle.class == "Crane"
            ) {
              this.VehicleType = "Crane";
            }
            if (
              typeof this.VehicleInspections.tyres != "undefined" &&
              this.VehicleInspections.tyres != ""
            ) {
              this.tyresData = JSON.parse(this.VehicleInspections.tyres);
            }
            if (
              typeof this.VehicleInspections.brakes != "undefined" &&
              this.VehicleInspections.brakes != ""
            ) {
              this.brakesData = JSON.parse(this.VehicleInspections.brakes);
            }
            if (this.VehicleInspections.rectifications) {
              this.VehicleInspections.rectifications = JSON.parse(
                this.VehicleInspections.rectifications
              );
            }
          } else {
            this.$router.push("/error-404");
          }
        });
      },
    },
  };
</script>
